import React from 'react';
import { HiChevronUp, HiChevronDown } from "react-icons/hi";

const NumericSpinnerButtons = ({
    onIncrement,
    onDecrement,
    disabled = false,
    className = "",
    inputRef
}) => {
    const handleUpClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (disabled) return;
        if (inputRef && inputRef.current) {
            inputRef.current.focus();
        }
        onIncrement();
    };

    const handleDownClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (disabled) return;
        if (inputRef && inputRef.current) {
            inputRef.current.focus();
        }
        onDecrement();
    };

    const handleMouseDown = (e) => {
        e.preventDefault();
    };

    return (
        <div
            className={`flex flex-col bg-slate-700 rounded text-slate-300 ${className} ${disabled ? 'opacity-40' : ''}`}
            onMouseDown={handleMouseDown}
            style={{ width: '12px', height: '20px' }}
        >
            <button
                className="flex items-center justify-center h-1/2 cursor-pointer hover:bg-slate-600 active:bg-slate-500 border-b border-slate-600 rounded-t"
                onClick={handleUpClick}
                onMouseDown={handleMouseDown}
            >
                <HiChevronUp size={12} />
            </button>
            <button
                className="flex items-center justify-center h-1/2 cursor-pointer hover:bg-slate-600 active:bg-slate-500 rounded-b"
                onClick={handleDownClick}
                onMouseDown={handleMouseDown}
            >
                <HiChevronDown size={12} />
            </button>
        </div>
    );
};

export default NumericSpinnerButtons;